import { createContext, useContext, useEffect, type ReactNode } from 'react'
import { useAdminPushNotifications } from '@/hooks/useAdminPushNotifications'
import { useAdminOrderAlerts } from '@/hooks/useAdminOrderAlerts'
import { setupOrderAlertSoundListener } from '@/lib/orderAlertSound'

type AdminPushContextValue = ReturnType<typeof useAdminPushNotifications>

const AdminPushContext = createContext<AdminPushContextValue | null>(null)

export function AdminPushProvider({ children }: { children: ReactNode }) {
  const value = useAdminPushNotifications()
  useAdminOrderAlerts()

  useEffect(() => {
    setupOrderAlertSoundListener()
  }, [])

  return (
    <AdminPushContext.Provider value={value}>{children}</AdminPushContext.Provider>
  )
}

export function useAdminPush() {
  const ctx = useContext(AdminPushContext)
  if (!ctx) {
    throw new Error('useAdminPush must be used within AdminPushProvider')
  }
  return ctx
}
